<template>
  <DatePicker
    v-bind="$props"
    :value="normalizedValue"
    @input="onInput"
    @on-change="onChange"
    @on-open-change="onOpenChange"
    @on-ok="onOk"
    @on-clear="onClear"
    @on-clickoutside="onClickoutside"
  ></DatePicker>
</template>

<script>
import moment from "moment";
export default {
  name: "uDatePicker",
  props: {
    valueFormat: {
      type: String
    },
    type: {
      type: String
    },
    format: {
      type: String
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: true
    },
    confirm: {
      type: Boolean,
      default: false
    },
    open: {
      type: Boolean,
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    timePickerOptions: {
      default: () => ({}),
      type: Object
    },
    splitPanels: {
      type: Boolean,
      default: false
    },
    showWeekNumbers: {
      type: Boolean,
      default: false
    },
    startDate: {
      type: Date
    },
    size: {
      type: String
    },
    placeholder: {
      type: String,
      default: ""
    },
    placement: {
      type: String
    },
    transfer: {
      type: Boolean
    },
    name: {
      type: String
    },
    elementId: {
      type: String
    },
    steps: {
      type: Array,
      default: () => []
    },
    value: {
      type: [Date, String, Array, Number],
    },
    options: {
      type: Object,
      default: () => ({})
    },
    separator: {
      type: String,
      default: " - "
    }
  },
  data() {
    return {
      normalizedValue: this.value
    };
  },
  watch: {
    value(now, old) {
      if(!old) return;
      this.normalizedValue = Array.isArray(now)
        ? now.map(d =>
            Number.isFinite(d) ? moment(d).format("YYYY-MM-DD hh:mm:ss") : d
          )
        : Number.isFinite(now)
        ? moment(now).format("YYYY-MM-DD hh:mm:ss")
        : now;
    }
  },
  methods: {
    formatDate(date) { 
      if (this.valueFormat && date) {
        let formatDate = d => {
          let m = moment(d);
          return this.valueFormat === "timestamp"
            ? m.valueOf()
            : m.format(this.valueFormat);
        };
        date = Array.isArray(date)
          ? date.map(d => (d ? formatDate(d) : d))
          : formatDate(date);
      }
      return date;
    },
    onInput(date) {
      this.$emit("input", this.formatDate(date));
    },
    onChange(date) {
      this.$emit("on-change", this.formatDate(date), date);
    },
    onOpenChange(value) {
      this.$emit("on-open-change", value);
    },
    onOk() {
      this.$emit("on-ok");
    },
    onClear() {
      this.$emit("on-clear");
    },
    onClickoutside(event) {
      this.$emit("on-clickoutside", event);
    }
  }
};
</script>
